module.exports = __webpack_public_path__ + "static/img/teaching-report.2aa96eae.png";